import * as Keycloak from 'keycloak-js';
import { storeInstance as Store } from '@/store';

const urlOpenID = process.env.VUE_APP_OPENID_URL_AUTHORIZATION
  ? process.env.VUE_APP_OPENID_URL_AUTHORIZATION
  : null;
const realm = process.env.VUE_APP_OPENID_REALM
  ? process.env.VUE_APP_OPENID_REALM
  : null;
const clientId = process.env.VUE_APP_OPENID_CLIENTID
  ? process.env.VUE_APP_OPENID_CLIENTID
  : null;
const onLoad = 'check-sso';
const responseMode = 'query';
const responseType = 'code';
const flow = 'standard';

const initOptions = {
  url: urlOpenID,
  realm: realm,
  clientId: clientId,
  onLoad: onLoad,
  checkLoginIframe: true,
  responseMode: responseMode,
  responseType: responseType,
  flow: flow
};

const keyIsExternal = '/ExternalUser';

const isDebugMode = Store.getters['PF/isDebugMode'];

let refreshTokenGlobal = null;
let keycloak = Keycloak(initOptions);

export async function init () {
  if (!urlOpenID || !realm || !clientId) {
    throw new Error('Config null mandatory parameters.');
  }
  let initUser = await keycloak
    .init({ checkLoginIframe: false })
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
  return initUser;
}

export async function isTokenValid () {
  const existData = await getUserInfo()
    .then(() => true)
    .catch(() => false);
  return existData;
}

export async function getUserInfo () {
  return keycloak.loadUserInfo();
}

export const tokenParsed = () => keycloak.tokenParsed;

export async function setData () {
  let tokenInfo = keycloak.tokenParsed;
  let isAuth = isAuthorized(tokenInfo);

  let tokenUser = setUser(tokenInfo);
  // Seteamos la Información del Usuario
  Store.commit('PF/setUser', tokenUser);

  if (!isAuth) return Store.commit('PF/authError');

  Store.commit('PF/authSuccess');

  // Iniciamos el refresco del token
  if (refreshTokenGlobal !== null) return;
  refreshToken();
}

export function login () {
  keycloak.login();
}

export function logout () {
  keycloak.logout();
  Store.commit('PF/clearDataUser');
}

export function goAccountURL () {
  keycloak.accountManagement();
}

export const authenticated = () => keycloak.authenticated;

export const token = () => 'Bearer ' + keycloak.token;

export function isAuthorized (token = null) {
  // If the user is internal, we do not check anything.
  let isExternal = getTypeUser(token.groups);
  if (!isExternal) return true;

  const roles = token.roles ?? null;
  if (roles === null) return false;

  let userRoles = getrolUser(roles);
  return userRoles.length > 0;
}

export function KeycloakInstance () {
  return keycloak;
}

export function getLanguage () {
  const tokenInfo = tokenParsed();
  const { locale } = tokenInfo;
  let language = 'es';
  if (locale) {
    language = locale;
  }
  return language;
}

// Private function
function refreshToken () {
  // Token Refresh
  refreshTokenGlobal = setInterval(() => {
    keycloak
      .updateToken(70)
      .then(refreshed => {
        if (refreshed) {
          if (isDebugMode) console.log('Token refreshed ' + refreshed);
        } else {
          // if (isDebugMode) {
          //   console.log(
          //     'Token not refreshed, valid for ' +
          //       Math.round(
          //         keycloak.tokenParsed.exp +
          //           keycloak.timeSkew -
          //           new Date().getTime() / 1000
          //       ) +
          //       ' seconds'
          //   );
          // }
        }
      })
      .catch(() => {
        if (isDebugMode) console.log('Failed to refresh token');
      });
  }, 6000);
}

function setUser (d) {
  const roles = getrolUser(d.roles);
  let isExternal = getTypeUser(d.groups);

  let arrayData = {
    nameid: d.sub,
    role: roles,
    email: d.email,
    given_name: d.given_name,
    family_name: d.family_name,
    aud: d.aud,
    isExternal: isExternal,
    locale: d.locale
  };

  setTimeout(() => window._paq.push(['setCustomDimensionValue', 1, d.Company]), 3000);
  setTimeout(() => window._paq.push(['setCustomDimensionValue', 2, isExternal]), 3000);

  return arrayData;
}

function getrolUser (roles) {
  return roles
    .filter((rol) => rol.startsWith(clientId))
    .map((rol) => rol.substring(rol.indexOf('_') + 1));
}

function getTypeUser (d) {
  return d.includes(keyIsExternal);
}
// End Private function
